import NetworkSpeed from 'network-speed'; // ES5

async function getNetworkDownloadSpeed(): Promise<string> {
  const testNetworkSpeed = new NetworkSpeed();
  const baseUrl = '/-/media/Default Website/cover.ashx';
  const fileSizeInBytes = 119719;
  const speed = await testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
  return speed.mbps === 'Infinity' ? '100' : speed.mbps;
}

export default getNetworkDownloadSpeed;
